import { UploadingReason } from 'reactApp/modules/uploading/serviceClasses/UploadingReason';

export class UploadingCancel extends UploadingReason {
    radarName = 'cancel_{SOURCE}_single';
    message = 'Отменено';
}
